import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b991b482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "el-form-item__content" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group d-flex flex-wrap" }
const _hoisted_27 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group d-flex flex-wrap" }
const _hoisted_34 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group d-flex flex-wrap" }
const _hoisted_41 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group d-flex flex-wrap" }
const _hoisted_44 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-group d-flex flex-wrap" }
const _hoisted_48 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group d-flex flex-wrap" }
const _hoisted_53 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-group d-flex flex-wrap" }
const _hoisted_56 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-group d-flex flex-wrap" }
const _hoisted_60 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "form-group d-flex flex-wrap" }
const _hoisted_63 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "form-group d-flex flex-wrap" }
const _hoisted_68 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "form-group d-flex flex-wrap" }
const _hoisted_71 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "form-group d-flex flex-wrap" }
const _hoisted_75 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-group d-flex flex-wrap" }
const _hoisted_78 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_79 = { class: "row mb-3" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "form-group d-flex flex-wrap" }
const _hoisted_82 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "form-group d-flex flex-wrap" }
const _hoisted_85 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group d-flex flex-wrap" }
const _hoisted_90 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_91 = { class: "col-md-6" }
const _hoisted_92 = { class: "form-group d-flex flex-wrap" }
const _hoisted_93 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-md-6" }
const _hoisted_96 = { class: "form-group d-flex flex-wrap" }
const _hoisted_97 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "form-group d-flex flex-wrap" }
const _hoisted_101 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_102 = { class: "col-md-6" }
const _hoisted_103 = { class: "form-group d-flex flex-wrap" }
const _hoisted_104 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "col-md-6" }
const _hoisted_107 = { class: "form-group d-flex flex-wrap" }
const _hoisted_108 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_109 = { class: "col-md-6" }
const _hoisted_110 = { class: "form-group d-flex flex-wrap" }
const _hoisted_111 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_112 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_113 = { class: "mb-0" }
const _hoisted_114 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_115 = { class: "mb-10" }
const _hoisted_116 = ["onClick"]
const _hoisted_117 = { class: "svg-icon svg-icon-3" }
const _hoisted_118 = ["onClick"]
const _hoisted_119 = { class: "svg-icon svg-icon-3" }
const _hoisted_120 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_121 = { class: "mb-0" }
const _hoisted_122 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_123 = { class: "mb-10" }
const _hoisted_124 = ["onClick"]
const _hoisted_125 = { class: "svg-icon svg-icon-3" }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = { class: "svg-icon svg-icon-3" }
const _hoisted_128 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_130 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_131 = { class: "indicator-label" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_133 = { class: "indicator-progress" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_135 = { class: "card mb-5 mb-xl-10" }
const _hoisted_136 = { class: "card-header border-0" }
const _hoisted_137 = { class: "card-title m-0" }
const _hoisted_138 = { class: "fw-boldest m-0" }
const _hoisted_139 = { class: "card-body border-top p-9" }
const _hoisted_140 = { class: "row" }
const _hoisted_141 = { class: "col-md-6" }
const _hoisted_142 = { class: "form-group d-flex flex-wrap" }
const _hoisted_143 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_145 = { class: "row" }
const _hoisted_146 = { class: "col-md-6" }
const _hoisted_147 = { class: "form-group d-flex flex-wrap" }
const _hoisted_148 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_149 = { class: "col-md-6" }
const _hoisted_150 = { class: "form-group d-flex flex-wrap" }
const _hoisted_151 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_152 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_153 = { class: "mb-0" }
const _hoisted_154 = { class: "mb-10" }
const _hoisted_155 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_156 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_157 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_159 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_160 = { class: "indicator-label" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_162 = { class: "indicator-progress" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_164 = { class: "card mb-5 mb-xl-10" }
const _hoisted_165 = { class: "card-header border-0" }
const _hoisted_166 = { class: "card-title m-0" }
const _hoisted_167 = { class: "fw-boldest m-0" }
const _hoisted_168 = { class: "card-body border-top p-9" }
const _hoisted_169 = { class: "row" }
const _hoisted_170 = { class: "col-md-6" }
const _hoisted_171 = { class: "form-group d-flex flex-wrap" }
const _hoisted_172 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_173 = { class: "el-form-item__content" }
const _hoisted_174 = { class: "col-md-6" }
const _hoisted_175 = { class: "form-group d-flex flex-wrap" }
const _hoisted_176 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_177 = { class: "el-form-item__content" }
const _hoisted_178 = { class: "col-md-6" }
const _hoisted_179 = { class: "form-group d-flex flex-wrap" }
const _hoisted_180 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_181 = { class: "el-form-item__content" }
const _hoisted_182 = { class: "col-md-6" }
const _hoisted_183 = { class: "form-group d-flex flex-wrap" }
const _hoisted_184 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_185 = { class: "el-form-item__content" }
const _hoisted_186 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_AddAddressModal = _resolveComponent("AddAddressModal")!
  const _component_AddConnectionModal = _resolveComponent("AddConnectionModal")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("accountConversions.leadIdentifier")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("influencerAccount.systemId")), 1),
                  _createVNode(_component_el_form_item, { prop: "system_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.system_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.system_id) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("influencerAccount.influencerAccountStatus")), 1),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.formData.status == 25 || _ctx.formData.status == 100)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.t("influencerAccount.deactivated")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.t("influencerAccount.activated")), 1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("influencerAccount.crmAccountID")), 1),
                  _createVNode(_component_el_form_item, { prop: "crm_account_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        value: _ctx.formData.crm_account_id + 100000,
                        type: "text",
                        disabled: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("influencerAccount.crmAccountStatus")), 1),
                  _createElementVNode("div", {
                    class: "el-form-item__content",
                    innerHTML: _ctx.getCrmAccountStatus(_ctx.formData.crm_account_status)
                  }, null, 8, _hoisted_23)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("influencerAccount.lifecycle")), 1),
                  _createVNode(_component_el_form_item, { prop: "lifecycle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.lifecycle,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.lifecycle) = $event)),
                        clearable: "",
                        style: {"width":"100%"},
                        autocomplete: "off",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lifecycleOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("influencerAccount.salutation")), 1),
                  _createVNode(_component_el_form_item, { prop: "salutation" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.salutation,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.salutation) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.men'),
                            value: "1"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.women'),
                            value: "2"
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("influencerAccount.firstname")), 1),
                  _createVNode(_component_el_form_item, { prop: "first_name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.first_name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.first_name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("influencerAccount.lastname")), 1),
                  _createVNode(_component_el_form_item, { prop: "last_name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.last_name,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.last_name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("influencerAccount.source")), 1),
                  _createVNode(_component_el_form_item, { prop: "source" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.source,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.source) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("influencerAccount.channel")), 1),
                  _createVNode(_component_el_form_item, { prop: "channel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.channel,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.channel) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.t("influencerAccount.industry")), 1),
                  _createVNode(_component_el_form_item, { prop: "industry" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.industry,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.industry) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industryOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("accountConversions.leadSegmentation")), 1),
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t("accountConversions.mbSegmentation")), 1),
                  _createVNode(_component_el_form_item, { prop: "mb_segmentation" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.mb_segmentation,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.mb_segmentation) = $event)),
                        clearable: "",
                        multiple: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mbSegmentationOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.t("accountConversions.stage")), 1),
                  _createVNode(_component_el_form_item, { prop: "stage" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.stage,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.stage) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off",
                        onChange: _ctx.changeStart
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "onChange"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.t("accountConversions.contactStart")), 1),
                  _createVNode(_component_el_form_item, { prop: "contact_start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.contact_start,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.contact_start) = $event)),
                        type: "date",
                        style: {"width":"100%"},
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.t("accountConversions.expiryDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "expiry_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.expiry_date,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.expiry_date) = $event)),
                        type: "date",
                        style: {"width":"100%"},
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_ctx.userInfo.advanced_manage)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("influencerAccount.accountInformation")), 1),
                  _hoisted_64,
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.t("influencerAccount.registrationDate")), 1),
                        _createVNode(_component_el_form_item, { prop: "registration_date" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.formData.registration_date,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.registration_date) = $event)),
                              type: "datetime",
                              disabled: "",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.t("influencerAccount.firstLogin")), 1),
                        _createVNode(_component_el_form_item, { prop: "first_login_time" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.formData.first_login_time,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.first_login_time) = $event)),
                              type: "datetime",
                              disabled: "",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.t("influencerAccount.mobile")), 1),
                        _createVNode(_component_el_form_item, { prop: "mobile" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "number",
                              modelValue: _ctx.formData.mobile,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                              modelModifiers: { number: true },
                              placeholder: _ctx.t('common.plsEnter'),
                              class: "input-with-select"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.formData.mobile_country_code,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.mobile_country_code) = $event)),
                                  filterable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  style: {"width":"110px"},
                                  autocomplete: "off"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneCodeOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.t("influencerAccount.locationOfMobileNo")), 1),
                        _createVNode(_component_el_form_item, { prop: "location_of_mobile" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.location_of_mobile,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.location_of_mobile) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.t("influencerAccount.wechatAccount")), 1),
                        _createVNode(_component_el_form_item, { prop: "wechat_account" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.wechat_account,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.wechat_account) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.t("influencerAccount.bcQuota")), 1),
                        _createVNode(_component_el_form_item, { prop: "bc_quota" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.bc_quota,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.bc_quota) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("influencerAccount.personalInformation")), 1),
                  _hoisted_86,
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.t("influencerAccount.email")), 1),
                        _createVNode(_component_el_form_item, { prop: "email" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "email",
                              modelValue: _ctx.formData.email,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.email) = $event)),
                              modelModifiers: { email: true },
                              placeholder: _ctx.t('common.plsEnter')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.t("influencerAccount.phone")), 1),
                        _createVNode(_component_el_form_item, { prop: "phone" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "number",
                              modelValue: _ctx.formData.phone,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.phone) = $event)),
                              modelModifiers: { number: true },
                              placeholder: _ctx.t('common.plsEnter')
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.t("influencerAccount.birthday")), 1),
                        _createVNode(_component_el_form_item, { prop: "birthday" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.formData.birthday,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.birthday) = $event)),
                              type: "date",
                              clearable: "",
                              placeholder: _ctx.t('common.pickDate'),
                              style: {"width":"100%"},
                              onChange: _cache[22] || (_cache[22] = ($event: any) => (
                      _ctx.commonChangeDefaultDate($event, _ctx.formData, 'birthday')
                    ))
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.t("influencerAccount.photo")), 1),
                        _createVNode(_component_el_form_item, { prop: "photo" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_upload, {
                              action: _ctx.uploadAccountdPhoto,
                              headers: _ctx.uploadHeaders,
                              "list-type": "picture-card",
                              "file-list": _ctx.photoList,
                              "on-preview": _ctx.handlePictureCardPreview,
                              "on-remove": _ctx.handlePhotoRemove,
                              limit: "1",
                              "on-success": _ctx.handlePhotoChange,
                              name: "photo",
                              disabled: !_ctx.checkPermissionFlag({ auth: ['update'] })
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_plus)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["action", "headers", "file-list", "on-preview", "on-remove", "on-success", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.t("influencerAccount.personalId")), 1),
                        _createVNode(_component_el_form_item, { prop: "personal_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.personal_id,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.personal_id) = $event)),
                              type: "text",
                              placeholder: _ctx.t('common.plsEnter'),
                              class: "input-with-select"
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.t("influencerAccount.personalIdFrontSide")), 1),
                        _createVNode(_component_el_form_item, { prop: "personal_id_front" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_upload, {
                              action: _ctx.uploadBcPersonIdFront,
                              headers: _ctx.uploadHeaders,
                              "list-type": "picture-card",
                              "file-list": _ctx.BcPersonIdFrontList,
                              "on-preview": _ctx.handlePictureCardPreview,
                              "on-remove": _ctx.handlePersonalFrontIDRemove,
                              "on-success": _ctx.handlePersonalFrontIDChange,
                              limit: "1",
                              name: "personal_id_front",
                              disabled: !_ctx.checkPermissionFlag({ auth: ['update'] })
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_plus)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["action", "headers", "file-list", "on-preview", "on-remove", "on-success", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.t("influencerAccount.personalIdBackSide")), 1),
                        _createVNode(_component_el_form_item, { prop: "personal_id_reverse" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_upload, {
                              action: _ctx.uploadBcPersonIdReverse,
                              headers: _ctx.uploadHeaders,
                              "list-type": "picture-card",
                              "file-list": _ctx.BcPersonIdReverseList,
                              "on-preview": _ctx.handlePictureCardPreview,
                              "on-remove": _ctx.handlePersonalReverseIDRemove,
                              "on-success": _ctx.handlePersonalReverseIDChange,
                              limit: "1",
                              name: "personal_id_reverse",
                              disabled: !_ctx.checkPermissionFlag({ auth: ['update'] })
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_plus)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["action", "headers", "file-list", "on-preview", "on-remove", "on-success", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("h3", _hoisted_113, _toDisplayString(_ctx.t("influencerAccount.addressInformation")), 1),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      type: "button",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_add_address",
                      title: "Add",
                      class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleAddAddress && _ctx.handleAddAddress(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_114, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                      ])
                    ])), [
                      [_directive_auth, { auth: ['update'] }]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _createVNode(_component_el_table, {
                      data: _ctx.addressTableData,
                      style: {"width":"100%"},
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.addressName'),
                          prop: "name"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.addressStreet'),
                          prop: "street"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.addressZipCode'),
                          prop: "zip_code"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.addressCity'),
                          prop: "city"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.addressCountry'),
                          prop: "country_iso_2",
                          formatter: _ctx.getCountryName
                        }, null, 8, ["label", "formatter"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.addressType'),
                          prop: "type",
                          formatter: _ctx.getAddressTypeLabel
                        }, null, 8, ["label", "formatter"]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                          label: "",
                          width: "100",
                          align: "right"
                        }, {
                          default: _withCtx(({ $index, row }) => [
                            _createElementVNode("button", {
                              type: "button",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modal_add_address",
                              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                              onClick: ($event: any) => (_ctx.handleEditAddress($index, row))
                            }, [
                              _createElementVNode("span", _hoisted_117, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                              ])
                            ], 8, _hoisted_116),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                              onClick: ($event: any) => (_ctx.handleDeleteAddress($index, row))
                            }, [
                              _createElementVNode("span", _hoisted_119, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                              ])
                            ], 8, _hoisted_118)
                          ]),
                          _: 1
                        })), [
                          [_directive_auth, { auth: ['update'] }]
                        ])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("h3", _hoisted_121, _toDisplayString(_ctx.t("influencerAccount.socialConnection")), 1),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      type: "button",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_add_connection",
                      title: "Add",
                      class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
                      onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.handleAddConnection && _ctx.handleAddConnection(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_122, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                      ])
                    ])), [
                      [_directive_auth, { auth: ['update'] }]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_123, [
                    _createVNode(_component_el_table, {
                      data: _ctx.connectionTableData,
                      style: {"width":"100%"},
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.socialConnectionAccount'),
                          prop: "account_number"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.socialConnectionType'),
                          prop: "type",
                          formatter: _ctx.getAaccountTypeLabel
                        }, null, 8, ["label", "formatter"]),
                        _createVNode(_component_el_table_column, {
                          label: 
                  _ctx.t('influencerAccount.socialConnectionVerificationStatus')
                
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", _ctx.getStatusLabel(row.status).statusClass])
                            }, _toDisplayString(_ctx.getStatusLabel(row.status).str), 3)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.socialConnectionNotes'),
                          prop: "notes"
                        }, null, 8, ["label"]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                          label: "",
                          width: "100",
                          align: "right"
                        }, {
                          default: _withCtx(({ $index, row }) => [
                            _createElementVNode("button", {
                              type: "button",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modal_add_connection",
                              title: "Add",
                              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                              onClick: ($event: any) => (_ctx.handleEditConnection($index, row))
                            }, [
                              _createElementVNode("span", _hoisted_125, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                              ])
                            ], 8, _hoisted_124),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                              onClick: ($event: any) => (_ctx.handleDeleteConnection($index, row))
                            }, [
                              _createElementVNode("span", _hoisted_127, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                              ])
                            ], 8, _hoisted_126)
                          ]),
                          _: 1
                        })), [
                          [_directive_auth, { auth: ['update'] }]
                        ])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_128, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_129,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_130, [
              _createElementVNode("span", _hoisted_131, [
                _hoisted_132,
                _createTextVNode(_toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_133, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_134
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_135, [
          _createElementVNode("div", _hoisted_136, [
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("h3", _hoisted_138, _toDisplayString(_ctx.t("influencerAccount.influencerGroup")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_139, [
            _createElementVNode("div", _hoisted_140, [
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("label", _hoisted_143, _toDisplayString(_ctx.t("influencerAccount.assignedGroup")), 1),
                  _createVNode(_component_el_form_item, { prop: "assigned_group" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.assigned_group,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.assigned_group) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"},
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_ctx.userInfo.advanced_manage)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("influencerAccount.magicBeanCycle")), 1),
                  _hoisted_144,
                  _createElementVNode("div", _hoisted_145, [
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.t("influencerAccount.activateCycle")), 1),
                        _createVNode(_component_el_form_item, {
                          prop: "cycle_status",
                          class: "form-item-status"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_switch, {
                              modelValue: _ctx.formData.cycle_status,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.cycle_status) = $event)),
                              "active-value": "20",
                              "inactive-value": "0"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      _createElementVNode("div", _hoisted_150, [
                        _createElementVNode("label", _hoisted_151, _toDisplayString(_ctx.t("influencerAccount.assignedCycle")), 1),
                        _createVNode(_component_el_form_item, { prop: "assigned_cycle" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: _ctx.formData.__show.assigned_cycle,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.__show.assigned_cycle) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("h3", _hoisted_153, _toDisplayString(_ctx.t("influencerAccount.cycleMembers")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_154, [
                    _createVNode(_component_el_table, {
                      data: _ctx.formData.assigned_cycle_list,
                      style: {"width":"100%"},
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "ID",
                          prop: "system_id",
                          width: "150"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.firstname'),
                          prop: "first_name"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.lastname'),
                          prop: "last_name"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.phone'),
                          prop: "mobile"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.assignedGroup'),
                          prop: "assigned_group"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.rfmProfilingRegistrationDate'),
                          prop: "registration_date"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _ctx.t('influencerAccount.influencerAccountStatus')
                        }, {
                          default: _withCtx(({ row }) => [
                            (row.status == 10)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_155, _toDisplayString(_ctx.t("influencerAccount.activated")), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_156, _toDisplayString(_ctx.t("influencerAccount.deactivated")), 1))
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_158,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_159, [
              _createElementVNode("span", _hoisted_160, [
                _hoisted_161,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_162, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_163
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_164, [
      _createElementVNode("div", _hoisted_165, [
        _createElementVNode("div", _hoisted_166, [
          _createElementVNode("h3", _hoisted_167, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_168, [
        _createElementVNode("div", _hoisted_169, [
          _createElementVNode("div", _hoisted_170, [
            _createElementVNode("div", _hoisted_171, [
              _createElementVNode("label", _hoisted_172, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_173, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_174, [
            _createElementVNode("div", _hoisted_175, [
              _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_177, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_178, [
            _createElementVNode("div", _hoisted_179, [
              _createElementVNode("label", _hoisted_180, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_181, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_182, [
            _createElementVNode("div", _hoisted_183, [
              _createElementVNode("label", _hoisted_184, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_185, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          style: {"width":"100%"},
          src: _ctx.dialogImageUrl,
          alt: ""
        }, null, 8, _hoisted_186)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_AddAddressModal, {
      id: _ctx.addressId,
      "account-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.updateAddressList,
      onResetForm: _ctx.handleAddAddress
    }, null, 8, ["id", "account-id", "onUpdateList", "onResetForm"]),
    _createVNode(_component_AddConnectionModal, {
      id: _ctx.connectionId,
      "account-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.updateConnectionList,
      onResetForm: _ctx.handleAddConnection
    }, null, 8, ["id", "account-id", "onUpdateList", "onResetForm"])
  ], 64))
}